import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangSlIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "b",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 18,
			height: 18,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M17.436 9A8.439 8.439 0 1 1 .558 9a8.439 8.439 0 0 1 16.878 0Z",
				fill: "#fff"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#b)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M17.438 17.438v-5.625H.563v5.624h16.875Z",
					fill: "#E32D3C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.438 11.813V6.186H.563v5.625h16.875Z",
					fill: "#2980B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M17.438 6.188V.563H.563v5.625h16.875Z",
					fill: "#fff"
				}),
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#c)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "m7.96 6.888.186-2.75a5.36 5.36 0 0 0-4.592 0l.187 2.75A2.977 2.977 0 0 0 5.85 9.537a2.977 2.977 0 0 0 2.11-2.649Z",
							fill: "#2980B9"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M4.128 7.26A2.645 2.645 0 0 0 5.85 9.189a2.646 2.646 0 0 0 1.722-1.927L6.71 6.113l-.344.46-.517-1.034-.516 1.033-.345-.459-.86 1.148Z",
							fill: "#fff"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M4.205 7.548a.574.574 0 0 0 .784.21.574.574 0 0 1 .574 0 .574.574 0 0 0 .574 0 .574.574 0 0 1 .574 0 .574.574 0 0 0 .784-.21v.166a.574.574 0 0 1-.784.21.574.574 0 0 0-.574 0 .574.574 0 0 1-.574 0 .574.574 0 0 0-.574 0 .574.574 0 0 1-.784-.21v-.166Z",
							fill: "#005DA4"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M4.205 7.879a.574.574 0 0 0 .784.21.574.574 0 0 1 .574 0 .574.574 0 0 0 .574 0 .574.574 0 0 1 .574 0 .574.574 0 0 0 .784-.21v.166a.574.574 0 0 1-.784.21.574.574 0 0 0-.574 0 .574.574 0 0 1-.574 0 .574.574 0 0 0-.574 0 .574.574 0 0 1-.784-.21v-.166Z",
							fill: "#005DA4"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m5.85 4.75.043.14.144-.032-.1.107.1.108-.144-.033-.043.14-.043-.14-.143.033.1-.108-.1-.107.143.033.043-.141Zm-.646-.86.043.14.144-.033-.1.108.1.107-.144-.033-.043.141-.043-.14-.143.032.1-.107-.1-.108.143.033.043-.14Zm1.292 0 .043.14.143-.033-.1.108.1.107-.143-.033-.043.141-.043-.14-.144.032.1-.107-.1-.108.144.033.043-.14Z",
							fill: "#FD0"
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m3.716 4.065.19 2.812A2.811 2.811 0 0 0 5.85 9.363a2.811 2.811 0 0 0 1.944-2.486l.19-2.812c.054.026.107.05.162.074l-.187 2.75A2.977 2.977 0 0 1 5.85 9.536a2.977 2.977 0 0 1-2.11-2.649l-.186-2.75c.055-.023.108-.047.162-.073Z",
							fill: "#E32D3C"
						})
					]
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "c",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			transform: "translate(3.554 3.622)",
			d: "M0 0h4.591v5.915H0z"
		})
	})] })]
});
const ForwardRef = forwardRef(SvgLangSlIconmin);
export { ForwardRef as ReactComponent };
